<h3 class="mat-dialog-title aip-dialog-title">Add Access - {{getAccessText()}}</h3>
  <div class="mat-dialog-content aip-dialog-text">
    
    <div class="search-holder">
        <input type="text" class="search search-input" cdkFocusInitial placeholder="Search" [(ngModel)]="searchAdd" />            
        <button class="search-clear search-input" mat-button *ngIf="searchAdd!=''" matSuffix mat-icon-button aria-label="Clear" (click)="searchAdd=''">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-selection-list class="list stripe" [multiple]="true" [(ngModel)]="selectedThing" (selectionChange)="handleChange($event)">
        <ng-container *ngFor="let acnt of getData()">
          <mat-list-option [value]="acnt.id">
            <span class="list-name">{{acnt["name"]}}</span>
          </mat-list-option>
          <ng-container *ngIf="acnt.type === 'region'">
            <mat-list-option *ngFor="let sub of getSubData(acnt.name)" [value]="sub.id">          
              <span class="list-name custom-sub-option">{{sub["name"]}}</span>
            </mat-list-option>
          </ng-container>
        </ng-container>
    </mat-selection-list>

</div>
  <div class="mat-dialog-actions" align="end">
    <button class="mat-focus-indicator aip-button mat-raised-button mat-button-base mat-primary" (click)="ok()">Add</button>
    <button class="mat-focus-indicator aip-button-alt mat-raised-button mat-button-base" (click)="cancel()" cdkFocusInitial>Cancel</button>
</div>